import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

type PreenchimentoContext = {
    hasData: boolean;
    setHasData: Dispatch<SetStateAction<boolean>>;
};

const PreenchimentoContext = createContext<PreenchimentoContext>({} as PreenchimentoContext);

export function PreenchimentoProvider({ children }: { children: ReactNode }) {
    const [hasData, setHasData] = useState(false);

    return <PreenchimentoContext.Provider value={{ hasData, setHasData }}>{children}</PreenchimentoContext.Provider>;
}

export const usePreenchimentoContext = (): PreenchimentoContext => useContext(PreenchimentoContext);
